<template>
	<router-view></router-view>
</template>
<script>
import {
	removeFullSectionMargin,
	addFullSectionMargin,
} from '../../shared/utils/handle-section-margin';

export default {
	name: 'page-job-evaluation',
	mounted() {
		addFullSectionMargin();
	},
	beforeDestroy() {
		removeFullSectionMargin();
	},
};
</script>



// WEBPACK FOOTER //
// src/modules/job-evaluation/pages/page-job-evaluation.vue